export default "__VITE_ASSET__C6RZTo1a__"